import { http } from "Utils/http";
import { Col, Row } from 'react-bootstrap';
import {TextButton} from 'Components/Button';
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
//import {store} from 'Store';
import { useState, useEffect,useReducer } from "react";
import { useSelector, useDispatch } from "react-redux";
import {useLocation, useNavigate } from 'react-router-dom';
import { isInObject } from "Utils/utilityFunctions";
import DatatableDropdownEntryField from "Components/Datatable/DatatableComponents/DatatableDropdownEntryField";
import DatatableDropdownCheckboxesField from "Components/Datatable/DatatableComponents/DatatableDropdownCheckboxesField";
//import { FilterDrama } from "@mui/icons-material";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { ERROR_MESSAGES } from "Utils/constants";
import { httpDownload } from "Utils/httpDownload";
//import Download from '@mui/icons-material/FileDownloadOutlined';
import { ICONS } from "Utils/icons";


const dataTableExtraFilterReducer = (state, action) => {
    //console.log("print out filterReducer", state, action);
    switch (action.type) {
        case "SET_DATA":
            return {
                docCategoryId: action.docCategoryId,
	            docOwnerId: action.docOwnerId,
	            // the possible values for these three filters: "", "Y", "N"
                isPublicAccess: action.isPublicAccess,
                isOpenForComment: action.isOpenForComment,
                isDisabled: action.isDisabled,
            };
        case "UPDATE":
            return {
                ...state,
                [action.key]: action.value,
            };
    }
}

const ListDocumentsTable = ({ ...props}) => {
  // Date format: mm/dd/yyyy hh: mm
  const loginInfo = useSelector(state => state.loginInfo);
  const info = props.info;
  //const isPSOAdmin = info.isPSOAdmin;
  //const isPSOPPCAdmin = info.isPSOPPCAdmin;
  //const allowEdit = info.allowEdit;
  let location = useLocation();
  const filterData = info.filterData;
  const navigate = useNavigate();
    
  const dispatch = useDispatch();

  const [sortColumn, setSortColumn] = useState({
    sortField: "docDisplayName",
    sortDirection: "asc"
  });

  const [filter, setFilter] = useState(null);
  const [docFilter, setDocFilter] = useState(null);
  //const [extraFilter, extraFilterDispatch] = useReducer(dataTableExtraFilterReducer, docFilter);

  const [extraFilter, extraFilterDispatch] = useReducer(dataTableExtraFilterReducer, {});

useEffect(()=>{
    var passedData = location.state;
    //console.log("FILTER");
    //console.log(location);
    //console.log(passedData);

    if(isInObject("filter",passedData)) {
        //console.log("setFilter");
        //console.log(passedData.filter);
        setFilter(passedData.filter);
        setDocFilter({
            docCategoryId: 0,
	        docOwnerId: 0,
	        // the possible values for these three filters: "", "Y", "N"
            isPublicAccess: "",
            isOpenForComment: "",
            isDisabled: "",
        })
        extraFilterDispatch({
            type: "SET_DATA",
            docCategoryId: 0,
	        docOwnerId: 0,
            isPublicAccess: "",
            isOpenForComment: "",
            isDisabled: ""
        })
    }
    else {
        setFilter({
            startIndex:0,
            entryPerPage:25,
            sortingColumn:sortColumn.sortField,
            sortingOrder:sortColumn.sortDirection,
            searchTerm:""
        });
        setDocFilter({
            docCategoryId: 0,
	        docOwnerId: 0,
	        // the possible values for these three filters: "", "Y", "N"
            isPublicAccess: "",
            isOpenForComment: "",
            isDisabled: "",
        })

        extraFilterDispatch({
            type: "SET_DATA",
            docCategoryId: 0,
	        docOwnerId: 0,
            isPublicAccess: "",
            isOpenForComment: "",
            isDisabled: ""
        })
    }

},[])

/*
const handleDateFormat = (time) => {
    if(time!=null){
        let date = new Date(time);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let min = date.getMinutes();
        return (
            <div>
                {month < 10 ? "0" + month : month}/
                {day < 10 ? "0" + day : day}/
                {year + " "}
                {hour < 10 ? "0" + hour : hour}:
                {min < 10 ? "0" + min : min}
            </div>
        )
    }
    else{
        return (
            <div>
                
            </div>
        )
    }
    
  }

  const handleOrgNameFormat = (row) => {
    var idText = "";
    if(row.orgPSOId!=null){
        idText = "(" + row.orgPSOId + ")";
    }
    return row.psoName + " " + idText;
  }

  */

    const getTest = async (filter,docFilter) => {   
        var call = {
            documentFilter: docFilter,
            paginationRequest: filter
        };
        
        //console.log("CALL");
        //console.log(call);
        var url = '/api/dlms/listDocument';
        //const loginState = store.getState().loginInfo;
        
        return http.post(url, call,{
            headers: {
                "Authorization": "Bearer " + loginInfo.token
                //"Referrer-Policy": "strict-origin-when-cross-origin"
            }
        });
    }

    const getDocumentDownloadCall = async (docId) => {   
 
        //console.log(docId);
        var url = '/api/dlms/retrieveDocument';
        //const loginState = store.getState().loginInfo;
        
        return httpDownload.post(url, {"docId": docId},{ 
            responseType: 'blob',
            headers: {
                "Authorization": "Bearer " + loginInfo.token
                //"Referrer-Policy": "strict-origin-when-cross-origin"
            }
        });
    }

    const handleFileDownload = async (docId, fileName) => {
        const res = await getDocumentDownloadCall(docId);
    
        if (res) {
          // get filename from the res content-disposition
          const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
            
          let url = window.URL.createObjectURL(res.data);
          let a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a); // append the element to the dom
          a.click();
          a.remove(); // afterwards, remove the element  
        }
      }

    const getDocumentDownload = async (docId) => {
          
        await getDocumentDownloadCall(docId).then((res) => {
            //console.log(res);
            
            const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
        
            let url = window.URL.createObjectURL(res.data);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a); // append the element to the dom
            a.click();
            a.remove(); // afterwards, remove the element  
    
            }).catch((error) => {
                //console.log("Error caught while loading data: " + error);
    
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: ERROR_MESSAGES.DATA_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    },
                    error: error
                });
            });
           
        };

    const getListCols = (selectedList, sortingInfo)=>{
        const listUserColumns = [];
		/*
        const title = function ({rowName}) {
            //TestTitle {0} test {1}
            //Params: rowName, "valuehere"
            return "Click the link to edit user " + rowName + ".";
        }

        const orgNameTitle = function ({rowName}) {
            //TestTitle {0} test {1}
            //Params: rowName, "valuehere"
            return rowName.psoName;
        }

        const fullNameTitle = function ({rowName}) {
            //console.log(rowName);
            return "Click the link to view user " + rowName + ".";
        }
		*/
        const userState = function ({rowName}) {
           
            return {
                groupId: rowName.groupId, 
                backRedirect: {
                    path: location.pathname,
                    state: {
                        ...location.state,
                        filter
                    },
                    
                }
            };
        }

        const updateState = function ({rowName}) {
           
            return {
                groupId: rowName.groupId, 
                docId: rowName.docId, 
                backRedirect: {
                    path: location.pathname,
                    state: {
                        ...location.state,
                        filter
                    },
                    
                }
            };
        }

        const viewState = function ({rowName}) {
           
            return {
                docId: rowName.docId, 
                backRedirect: {
                    path: location.pathname,
                    state: {
                        ...location.state,
                        filter
                    },
                    
                }
            };
        }

        const handleDownloadDocData = function ( row ) {
           //console.log(row);
           handleFileDownload(row.docId);
           
        }
        const docDispNameState = function ({ rowName }) {
            //console.log("printout rowName", rowName);
            return rowName.docDisplayName;
        }

        const handleDocIdFormat = ({rowName}) => {
            //console.log(rowName);
            return rowName.groupId + " - " + rowName.docId;
        }

        listUserColumns.push(Datatable_Column({
            name:"Doc - Group ID", 
            columnName:["docId", "groupId"], 
            selectedRows: selectedList, 
            sortable:true, 
            //sortFieldNum:4, 
            /*isLink: false, */
            delimiter: "-",
            isLink:true, 
            linkData:{
                //title: null, 
                pathname: "/manage/viewDocument",
                text: null, 
                state:viewState
            },
            sortingInfo:sortingInfo
        }))
        listUserColumns.push(Datatable_Column({
            name:"Category", 
            columnName:"categoryName", 
            selectedRows: selectedList, 
            sortable:true, 
            //sortFieldNum:4,
            sortingInfo:sortingInfo
        }))
       
        listUserColumns.push(Datatable_Column({
            name:"Display Name", 
            columnName:"docDisplayName", 
            selectedRows: selectedList, 
            sortable:true, 
            sortFieldNum:4, 
            isButton: true, 
            buttonData: { 
                action: handleDownloadDocData, 
                text: null, 
                icon: ICONS.download
            }, 
            //title: "DOWNLOAD", 
            wordBreak: "all",
            sortingInfo:sortingInfo
        }))
        listUserColumns.push(Datatable_Column({
            name:"Owner", 
            columnName:"ownerName", 
            selectedRows: selectedList, 
            sortable:true, 
            sortFieldNum:4,
            sortingInfo:sortingInfo
        }))
        listUserColumns.push(Datatable_Column({
            name:"Public Access", 
            columnName:"allowPubAccess", 
            selectedRows:selectedList, 
            sortable:false, 
            sortFieldNum:4, 
            sortingInfo:sortingInfo
        }))
        listUserColumns.push(Datatable_Column({
            name:"Open For Comment", 
            columnName:"isOpenForComment", 
            selectedRows: selectedList, 
            sortable:false, 
            //sortFieldNum:4,
            sortingInfo:sortingInfo
        }))
        listUserColumns.push(Datatable_Column({
            name:"Disabled", 
            columnName:"isDisabled", 
            selectedRows: selectedList, 
            sortable:false, 
            //sortFieldNum:4,
            sortingInfo:sortingInfo
        }))


        //if(isPSOPPCAdmin==true && allowEdit==true){
        listUserColumns.push(Datatable_Column({
            name:"Edit", 
            columnName:"edit", 
            selectedRows:selectedList, 
            sortable:false, 
            sortFieldNum:4, 
            isLink:true, 
            linkData:{
                //title: null, 
                pathname: "/manage/createDocument",
                text: "Edit", 
                state:updateState
            },
            sortingInfo:sortingInfo
        }))
        listUserColumns.push(Datatable_Column({
            name:"Add New", 
            columnName:"addnew", 
            selectedRows:selectedList, 
            sortable:false, 
            sortFieldNum:4, 
            isLink:true, 
            linkData:{
                pathname: "/manage/createDocument",
                text: "Add New", 
                state:userState
            },
            sortingInfo:sortingInfo
        }))

        return listUserColumns;
      }

      const tableTitle = function () {
        return "Documents List";
      }
      
      const tableDescription = function() {
        return null;//"Select a user to view detailed information.";
      }
      const [selectedCount, setSelectedCount] = useState(0);


      const handleCreatePopup = (e) => {
        props.setShowPopup(true);
    }

    const handleYesNoCheckChange = (e, filter, dispatch, key) => {
        //console.log(e);
        //console.log(filter);
        //console.log(e.target.checked);

        if(e.target.checked==true){
             extraFilterDispatch({
                type: "UPDATE",
                key: key,
                value: e.target.value
            })
        }
        else{
            extraFilterDispatch({
                type: "UPDATE",
                key: key,
                value: ""
            })
        }
    }

    const handleOwnerChange = (e, filter, dispatch) => {

        extraFilterDispatch({
            type: "UPDATE",
            key: "docOwnerId",
            value: e.target.value
        })
    }

    const handleCategoryChange = (e, filter, dispatch) => {
        extraFilterDispatch({
            type: "UPDATE",
            key: "docCategoryId",
            value: e.target.value
        })
    }
      
    const extraSortingComp = (filter, dispatch) => {
        //console.log(filterData);
        //console.log(filter);
        return (
            <>
                <Row className="d-flex flex-wrap justify-content-start ps-3 pe-3 mt-4 mb-2 datatable-controls">
                    <Col lg={6} className="mt-1" >
                        <DatatableDropdownEntryField 
                            label="Show by Category" 
                            handleChange={(e) => handleCategoryChange(e, filter, dispatch)} 
                            values={filterData["catList"]} 
                            idKey={"categoryId"} 
                            textKey={"categoryName"}
                            defaultItem={{
                                id: 0,
                                text: "All Categories"

                            }}
                            unique="showCat"
                            filter={filter}
                            filterKey={"docCategoryId"}
                        ></DatatableDropdownEntryField>
                    </Col>
                    <Col lg={6} className="mt-1">
                        <DatatableDropdownEntryField 
                            label="Show by Owner" 
                            handleChange={(e) => handleOwnerChange(e, filter, dispatch)} 
                            values={filterData["ownerList"]} 
                            idKey={"ownerId"} 
                            textKey={"ownerName"}
                            defaultItem={{
                                id: 0,
                                text: "All Owners"

                            }}
                            unique="showOwn"
                            filter={filter}
                            filterKey={"docOwnerId"}
                        ></DatatableDropdownEntryField>
                    </Col>
                    
                    
                </Row>
                <Col className="d-flex flex-wrap column-gap-5 justify-content-start ps-3 pe-3 mt-2 mb-4 datatable-controls">
                    
                    <Col className="mt-1 flex-fit">
                        <DatatableDropdownCheckboxesField 
                            label="Public Access" 
                            handleChange={(e) => handleYesNoCheckChange(e, filter, dispatch, "isPublicAccess")} 
                            values={[
                                {
                                    id: "Y",
                                    text: "Yes"
                                },
                                {
                                    id: "N",
                                    text: "No"
                                }
                            ]} 
                            idKey={"id"} 
                            textKey={"text"}
                            unique="pubAccess"
                            filter={filter}
                            filterKey={"isPublicAccess"}
                            
                        ></DatatableDropdownCheckboxesField>
                    </Col>
                    <Col className="mt-1 flex-fit">
                        <DatatableDropdownCheckboxesField 
                            label="Open For Comment" 
                            handleChange={(e) => handleYesNoCheckChange(e, filter, dispatch, "isOpenForComment")} 
                            values={[
                                {
                                    id: "Y",
                                    text: "Yes"
                                },
                                {
                                    id: "N",
                                    text: "No"
                                }
                            ]} 
                            idKey={"id"} 
                            textKey={"text"}
                            unique="openFor"
                            filter={filter}
                            filterKey={"isOpenForComment"}
                            
                        ></DatatableDropdownCheckboxesField>
                    </Col>
                    <Col className="mt-1 flex-fit">
                        <DatatableDropdownCheckboxesField 
                            label="Disabled" 
                            handleChange={(e) => handleYesNoCheckChange(e, filter, dispatch, "isDisabled")} 
                            values={[
                                {
                                    id: "Y",
                                    text: "Yes"
                                },
                                {
                                    id: "N",
                                    text: "No"
                                }
                            ]} 
                            idKey={"id"} 
                            textKey={"text"}
                            unique="isDisabled"
                            filter={filter}
                            filterKey={"isDisabled"}
                            
                        ></DatatableDropdownCheckboxesField>
                    </Col>
                    
                </Col>
            </>
            
        )
    }

    const handleCreateDocument = () => {
        
        navigate(
            "/manage/createDocument",
            { state: {
                backRedirect: {
                    path: location.pathname,
                    state: location.state
                }
            }}
           
        );
    }

  return (
    <>
       
        { filter!=null && extraFilter!=null?
            <DatatableBase 

                tableClassName="listDocumentsTable" 
                getData={getTest} 
                
                filter = {filter}
                setFilter={setFilter}

                extraFilterDispatch={extraFilterDispatch}
                extraFilterReducer={dataTableExtraFilterReducer}
                extraFilter={extraFilter}
                extraSortingComp = {extraSortingComp}

                getListCols={getListCols} 
                setSelectedCount={setSelectedCount} 
                hasSelectableRows={false} 
                searchFieldText={"Search by document display name."} 
                
                datatableHeader={tableTitle()} 
                datatableDescription={tableDescription()}
                sortingColumn={sortColumn.sortField} 
                sortingOrder={sortColumn.sortDirection}
            >
                    {
                        <Col className="d-flex justify-content-end ">
                        {
                           <TextButton className="ms-auto " title="Click to Create a New Document" /*href={"users/createuser"}*/ onClick={handleCreateDocument} variant="normal" content={"Add New Document"}/>

                        }
                        
                        </Col>
                    }
               
            
            </DatatableBase>
            :null
        }  
    </>
  );
}

export default ListDocumentsTable;